<template>
  <div  >
    <div >
      <OrderListCommon :status="status" @listt="listt" :urlT="urlT"></OrderListCommon>
    </div>
  </div>
 
</template>

<script>
import OrderListCommon from "../common/OrderListCommon";
export default {
  created() {
    this.$emit("Active", 3); 
  },
  data() {
    return {
      status: 40,
      sendList: [],
       urlT:'/Particular/particularSucceed'
    };
  },
  methods: {
    listt(listt) {
      this.sendList = listt;
      this.$emit("list", this.sendList);
    }
  },
  components: {
    OrderListCommon
  }
};
</script>

<style scoped>
</style>